module.exports = __webpack_public_path__ + "img/banner.08b46b5c.png";